/* eslint-disable new-cap */
import './modules/lazysizes'
import '@magnetita/accordion'
import { ready } from '@titanio/utils'
import Router from '@titanio/router'
import textfield from '@magnetita/textfield'

ready(() => {
  const router = new Router()

  router.get(['/queroserforegon', '/queroserforegon/'], () => {
    import(
      /* webpackChunkName: "blockquote" */
      '@magnetita/blockquote'
    ).then((blockquote) => {
      return new blockquote.default()
    })
  })

  // router.get(['/solucoesparaempresas'], () => {
  //   import(
  //     /* webpackChunkName: "companies-lead" */
  //     '../containers/institutional/companies/lead/lead'
  //   ).then(({ default: Container }) => {
  //     const container = new Container()
  //     container.mount()
  //   })
  // })

  setTimeout(() => router.init(), 0)
  setTimeout(() => textfield.mount(), 0)
})
